class Newsletter extends HTMLElement{
    constructor(){
        super();
        
        this.button              = this.querySelector('#notify_me');
        this.email               = this.querySelector('#notify_email');
        this.birth               = this.querySelector("#notify_date");
        this.gender              = this.querySelector('#notify_gender');
        this.country             = this.querySelector('#notify_country');
        this.dialogContainer     = this.querySelector('.dialog__content');
        this.dialog_notify       = this.querySelector(".dialog__notification");
        this.dialog_notify_error = this.querySelector(".dialog__notification-error");
        this.close               = this.querySelector("#ModalClose");
        this.list_id             = this.dataset.id;
        this.open                = localStorage.getItem('newsletter');

        this.addEvents();
    }

    addEvents(){
        //open
        if(this.open != 'true'){
            setTimeout(()=>{
                this.setAttribute('open', '');
            }, 4000);
        }
        this.button.addEventListener("click", ()=>{
            if(this.handleError()){
                this.buildData();
            }
        })
        this.close.addEventListener("click", ()=>{
            this.removeAttribute("open");
            localStorage.setItem("newsletter", "true");
        })
    }

    handleError(){
        if(this.email.value == ""){
            this.email.classList.add("error");
            this.email.addEventListener("click",()=>{
                if(this.email.classList.contains("error")){
                    this.email.classList.remove("error")
                }
            })
            return false;
        }
        return true;
    }

    buildData(){
        let self = this;
        var settings = {
            "async": true,
            "crossDomain": true,
            "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
            "method": "POST",
            "headers": {
                "content-type": "application/x-www-form-urlencoded",
                "cache-control": "no-cache"
            },                                                                              
            "data": {
                "g": this.list_id, // replace LIST_ID with id of list to be subscribed
                "email": this.email.value,
                "$fields": "$birth, $gender, $country",
                "$birth": this.birth.value,
                "$gender": this.gender.value,
                "$country": this.country.value
            }
        };
        $.ajax(settings).done(function(response) {
            console.log(response);
            if(response.success == true){
                self.dialogContainer.style.display = "none";
                self.dialog_notify.style.display = "block";
                localStorage.setItem("newsletter", "true");
            }
            else{
                self.dialogContainer.style.display = "none";
                self.dialog_notify_error.style.display = "block";
            }
        })
        .fail(error =>{
            console.log(error);
        })
    }

    // async postData(url = '', data = {}) {
    //     // Default options are marked with *
    //     const response = await fetch(url, {
    //         method: 'POST', // *GET, POST, PUT, DELETE, etc.
    //         cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached,
    //         crossDomain: true,
    //         headers: {
    //             "content-type": "application/x-www-form-urlencoded"
    //         },
    //         data: data
    //     });
    //     return response.json(); // parses JSON response into native JavaScript objects
    // }
}

customElements.define("custom-newsletter", Newsletter);